import { render } from "./CardTermsView.vue?vue&type=template&id=b5c748b0"
import script from "./CardTermsView.vue?vue&type=script&lang=js"
export * from "./CardTermsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__